import React from "react";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";
import { useStripe } from "@stripe/react-stripe-js";
import { useLocation } from "react-router-dom";
import { Modal, SubTitle, event } from "@minerva-analytics/pantheon";
import { SITE_URL } from "../../constants";
import { 
  ModalTheme, 
  PriceButton, 
  ButtonContainer, 
  ModalText,
  PaddedButton,
  DisclaimerText
} from "./DonateModal.styles";

const priceInfo = {
  '$1': 'price_1I8Rm5CY36cVYYLv9Gx1Pxir',
  '$2': 'price_1I8Rm5CY36cVYYLvAVXbqVFQ',
  '$5':'price_1I8Rm5CY36cVYYLvAtLg6Qkp',
  '$10': 'price_1I8Rm5CY36cVYYLvJJMgfdmj',
}

const DonateModal = (props) => {
  const stripe = useStripe();
  const { hash } = useLocation();

  const handleClick = async (priceToken, price) => {
    // if stipe hasnt loaded yet, don't allow clicking
    if (!stripe) return;
    event([`click`, `donate-button`, `${price}`]);

    await stripe.redirectToCheckout({
      lineItems: [
        {
          price: `${priceToken}`,
          quantity: 1,
        },
      ],
      mode: "payment",
      successUrl: `${SITE_URL}/articles/#thanks`,
      cancelUrl: `${SITE_URL}/articles/#donate`,
    });
  };

  const Donate = () => (
    <>
      <SubTitle>Donate to back then history</SubTitle>
      <ModalText>
        <span>Thank you for considering donating to Back Then History!</span>
      </ModalText>
      <ModalText>Your donation will help us continue sharing the strange history behind everyday objects.</ModalText>
      <ModalText>
        If you would like to contribute, please select one of the recommended amounts below. This will redirect you to our payment platform. Thank you.
      </ModalText>
      <ModalText>Select a donation amount:</ModalText>
      <ButtonContainer>
        {Object.entries(priceInfo).map((price) => (
          <PriceButton 
            onClick={()=>handleClick(price[1], price[0])}
            key={price[0]}
          >
            {price[0]}
          </PriceButton>
        ))}
        <DisclaimerText>Back Then History is not a non-profit organization.</DisclaimerText>
      </ButtonContainer>
    </>
  );

  const Thanks = () => (
    <>
      <SubTitle>Thank you for your support!</SubTitle>
      <ModalText>Back Then History will use your donation to continue sharing the strange history behind everyday objects.</ModalText>
      <PaddedButton onClick={props.hide}>Explore our site &rarr;</PaddedButton>
    </>
  );

  return (
    <ThemeProvider theme={ModalTheme}>
      <Modal
        isShowing={props.isShowing}
        hide={props.hide}
        backdropClosesModal={props.backdropClosesModal}
        modalName="donate-modal"
      >
        {hash === `#thanks` ? Thanks() : Donate()}
      </Modal>
    </ThemeProvider>
  );
};

DonateModal.propTypes = {
  isShowing: PropTypes.bool,
  hide: PropTypes.func,
  backdropClosesModal: PropTypes.bool,
};

export default DonateModal;
